import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fromOrder } from '../store';
import { AnalyticsCartSnapshot, buildPlanCartSnapshot } from '../utils/analytics';

export const usePlanCartSnapshot = (): AnalyticsCartSnapshot => {
  const productsPreview = useSelector(fromOrder.selectOrderProductsPreview);

  return useMemo(
    () => buildPlanCartSnapshot({ productsPreview }),
    [productsPreview],
  );
};
